/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PaginationFilter } from "../types/PaginationFilter.ts";

export const paginationFilterSchema = z.object({
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
}) as unknown as ToZod<PaginationFilter>;
